import { format } from 'date-fns';
import DataFlowDetailActionsContainer from 'js/components/data_flows/DataFlowDetailActionsContainer';
import { getResourceEntity } from 'js/lib/PipelineUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import { isEmpty } from 'lodash';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import PipelineStatusChip from 'new/components/pipelines/PipelineStatusChip/PipelineStatusChip';
import Typography from 'new/elements/TypographySupport';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './PipelineFormHeader.module.scss';
import FlowTypeIcon from './cards/FlowTypeIcon';

const DATE_FORMAT = 'MMM dd, yyyy';

export const PipelineFormHeader = ({ source, toggleCloneFlowModal }) => {
  if (isEmpty(source)) {
    return null;
  }

  const entities = useSelector((state: any) => state.entities);
  const metaInfoById = useSelector((state: any) => state.paging.metaInfoById);
  const { flowNodes, projects, vendors } = entities;
  const data = getResourceEntity(source, entities);
  const connectionOrVendorType = getConnectionOrVendorType(
    data,
    vendors,
    'source_type',
    'vendor_id',
  );
  const connectionInfo = metaInfoById?.[connectionOrVendorType] || null;
  const project = projects[data.project_id] || null;
  const rootFlowNode = flowNodes[data.flow_node_id];
  const description = rootFlowNode?.description || data.description;

  let sourceIcon;
  let sourceName;

  if (connectionInfo) {
    sourceIcon = connectionInfo.iconSm;
    sourceName = connectionInfo.name;
  } else {
    sourceName = connectionOrVendorType;
  }

  return (
    <div className={styles.root} data-testid={`pipeline-origin-card-${data.flow_node_id}`}>
      <div>
        <Typography className="ellipsis" variant="button2">
          {rootFlowNode?.name || data.name}
        </Typography>
        {description && (
          <Typography className="ellipsis" variant="body3" component="p">
            {description}
          </Typography>
        )}
        <div
          data-testid={`pipeline-origin-card-${data.flow_node_id}-flow-id`}
          className={styles.bottom}
        >
          <div className={styles.connectorType}>
            {sourceIcon && <img className={styles.icon} src={sourceIcon} />}
            {sourceName}
          </div>
          <ChipWithCopy toCopy={data.flow_node_id}>FLOW {data.flow_node_id}</ChipWithCopy>
          <FlowTypeIcon data={data} />
          <Typography className={styles.createdAt} variant="body3">
            Created on {format(new Date(data.created_at), DATE_FORMAT)}
          </Typography>
        </div>
      </div>
      <div className={styles.right}>
        <PipelineStatusChip
          id={data.flow_node_id}
          status={data.status}
          archivalStatus={data?.archival_status}
          showRuntimeIndicator={false}
        />
        <DataFlowDetailActionsContainer
          data={data}
          projectId={project?.id}
          inPipeline
          toggleCloneFlowModal={toggleCloneFlowModal}
        />
      </div>
    </div>
  );
};

export default PipelineFormHeader;
